import React from 'react';
export function LoanTableHeader() {
  const headers = ['Loan #', 'Client', 'Submitted', 'Team Lead', 'LOA', 'Processor', 'Activity', 'Lender', 'Type', 'Amount', 'ST', 'Lock', 'CD', 'Cond.', 'Appraisal', 'Appr. Xfer', 'Payoff', 'HOI', 'Title', 'Push'];
  return <thead className="sticky top-0 z-10" data-id="element-9">
      <tr className="bg-slate-50/80 border-b border-slate-200/60" data-id="element-10">
        {headers.map(label => <th key={label} className="px-3 py-3 text-left text-[12px] font-bold text-slate-600 uppercase tracking-wider whitespace-nowrap" data-id="element-11">
            {label}
          </th>)}
      </tr>
    </thead>;
}